/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { REQUIRED_MESSAGE } from "../../../constants";
import * as yup from "yup";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { styleExam } from "../styleExam";
import {
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@material-ui/core";
import { initialStateForm } from "../headers";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import deLocale from "date-fns/locale/es";
import { useStateValue } from "../../../context/store";
import moment from "moment";
import { StyledCheckbox } from "../../../utils/functionsUtils";

const NextFormCreateOrder = ({
  dataMaestras,
  regional,
  charges,
  stateInitial,
  setMessage,
  message,
  handleClickExam,
  userState,
  typeExam,
  isFieldDisabled,
}) => {
  const classes = styleExam();
  const [{}, dispatch] = useStateValue();
  const soloLetras = /^(([A-Za-zÀ-ÿÑñ])+[ ]?)*$/g;
  const [stateName, setStateName] = useState(false);
  const [stateSurname, setStateSurname] = useState(false);
  const [stateObservation, setStateObservation] = useState(false);
  const [stateExamType, setStateExamType] = useState(false);
  const [valueExam, setValueExam] = useState([]);
  const [check, setCheck] = useState({});
  const [otherSelected, setOtherSelected] = useState(false);

  const schema = yup.object().shape({
    firstName: isFieldDisabled
      ? null
      : yup
          .string()
          .required(REQUIRED_MESSAGE)
          .min(3, "Ingrese mínimo 3 caracteres")
          .max(50, "Ingrese máximo 50 caracteres")
          .matches(soloLetras, "Ingrese un nombre válido"),
    secondName: isFieldDisabled
      ? null
      : stateName
      ? null
      : yup
          .string()
          .notRequired()
          .min(3, "Ingrese mínimo 3 caracteres")
          .max(50, "Ingrese máximo 50 caracteres")
          .matches(soloLetras, "Ingrese un nombre válido"),
    surname: isFieldDisabled
      ? null
      : yup
          .string()
          .required(REQUIRED_MESSAGE)
          .min(3, "Ingrese mínimo 3 caracteres")
          .max(50, "Ingrese máximo 50 caracteres")
          .matches(soloLetras, "Ingrese un apellido válido"),
    secondSurname: stateSurname
      ? null
      : yup
          .string()
          .notRequired()
          .min(3, "Ingrese mínimo 3 caracteres")
          .max(50, "Ingrese máximo 50 caracteres")
          .matches(soloLetras, "Ingrese un apellido válido"),
    regionalId: isFieldDisabled
      ? null
      : yup.string().required(REQUIRED_MESSAGE),
    documentType: yup.string().nullable().notRequired(),
    document: yup.string().nullable().notRequired(),
    examType: yup.string().required(REQUIRED_MESSAGE),
    email: yup
      .string()
      .required(REQUIRED_MESSAGE)
      .email("Ingrese un correo electrónico válido")
      .min(8, "Ingrese mínimo 8 caracteres")
      .max(50, "Ingrese máximo 50 caracteres"),
    charge: isFieldDisabled ? null : yup.string().required(REQUIRED_MESSAGE),
    observation: stateObservation
      ? null
      : yup
          .string()
          .notRequired()
          .min(3, "Ingrese mínimo 3 caracteres")
          .max(500, "Ingrese máximo 500 caracteres"),
    retiro: stateExamType
      ? null
      : yup
          .date()
          .nullable()
          .required(REQUIRED_MESSAGE)
          .min(
            new Date(1899, 11, 31, 23, 59, 29),
            `Ingrese una fecha superior al año 1900`
          )
          .nullable()
          .typeError("Ingrese un formato de fecha válido"),
  });

  const {
    register,
    handleSubmit,
    control,
    setValue,
    formState: { errors },
    watch,
    getValues,
  } = useForm({
    resolver: yupResolver(schema),
    initialStateForm,
    mode: "all",
    reValidateMode: "onChange",
  });

  const handleClickClose = () => {
    setMessage({ ...message, open: false });
  };

  const onSubmit = (data) => {
    if (valueExam?.length === 0) {
      setMessage({
        description: `Debe seleccionar el tipo de examen`,
        textButtonSubmit: "Aceptar",
        handleClick: () => handleClickClose(),
        oneButtons: true,
        type: "WARNING",
        open: true,
      });
      return;
    }
    const exam = valueExam?.filter((x) => x?.description === "Otro");
    if (exam?.length > 0) {
      const examMap = exam?.map((x) => x?.observation).toString();
      if (examMap === "" || examMap === null) {
        setMessage({
          description: `Por favor indicar cuál tipo de examen al seleccionar la opción 'Otro'`,
          textButtonSubmit: "Aceptar",
          handleClick: () => handleClickClose(),
          oneButtons: true,
          type: "WARNING",
          open: true,
        });
        return;
      }
    }
    objectBySend(data);
  };

  const objectBySend = (data) => {
    const listExam = valueExam.map((exam) => {
      const newObjectExam = {
        id: exam.id,
        observation: exam.observation,
      };
      return newObjectExam;
    });

    const newData = {
      firstName: data?.firstName ? data?.firstName : userState.firstName,
      secondName: data?.secondName ? data?.secondName : userState.secondName,
      surname: data?.surname ? data?.surname : userState.surname,
      secondSurname: data?.secondSurname
        ? data.secondSurname
        : userState.secondSurname,
      documentType: stateInitial?.documentType,
      document: stateInitial?.document,
      regionalId: data?.regionalId ? data?.regionalId : useState.regional.id,
      chargeId: data?.charge ? data.charge : userState.charge?.id,
      orderType: data?.examType,
      observations: data?.observation,
      retirementDate: data?.retiro
        ? moment(data?.retiro).format("YYYY-MM-DDTHH:mm")
        : null,
      userEmail: data?.email ? data?.email : userState.email,
      typeExamMedicalList: listExam,
    };
    setMessage({
      description: "¿Esta seguro que se desea guardar orden de examen médico? ",
      textButtonSubmit: "Guardar",
      handleClick: () => handleClickExam(newData),
      handleClickOut: () => handleClickClose(),
      type: "QUESTION",
      open: true,
    });
  };

  useEffect(() => {
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Generar orden exámenes médicos",
      breadCrumbSubText: "Generar orden exámenes médicos",
      index: 241,
      isSubmitOrderExam: true,
    });
  }, [dispatch]);

  useEffect(() => {
    if (userState) {
      setValue("documentType", userState?.documentType);
      setValue("document", userState?.document);
      setValue("examType", stateInitial?.examType);
      setValue("firstName", userState?.firstName);
      setValue("secondName", userState?.secondName);
      setValue("surname", userState?.surname);
      setValue("secondSurname", userState?.secondSurname);
      setValue("charge", userState?.charge?.id);
      setValue("email", userState?.email);
      setValue("regionalId", userState?.regional?.id);
    } else {
      setValue("documentType", stateInitial?.documentType);
      setValue("document", stateInitial?.document);
      setValue("examType", stateInitial?.examType);
    }
  }, [userState]);

  const handleUserKeyPressDocumento = (e) => {
    var form = getValues();
    if (form.documentType !== "PP") {
      let validChars = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"];
      if (!validChars.includes(e.key)) {
        e.preventDefault();
      }
    }
  };

  const seeSecondName = watch("secondName");
  const seeSecondSurname = watch("secondSurname");
  const validateObservation = watch("observation");
  const validateExamType = watch("examType");

  useEffect(() => {
    if (seeSecondName === "") {
      setStateName(true);
    } else {
      setStateName(false);
    }
    if (seeSecondSurname === "") {
      setStateSurname(true);
    } else {
      setStateSurname(false);
    }

    if (validateObservation === "") {
      setStateObservation(true);
    } else {
      setStateObservation(false);
    }
    if (validateExamType === "RETIREMENT") {
      setStateExamType(false);
    } else {
      setStateExamType(true);
    }
  }, [
    seeSecondName,
    seeSecondSurname,
    validateObservation,
    validateExamType,
    valueExam,
  ]);

  const onChangeExam = (e, data) => {
    if (data?.id) {
      const newArray = valueExam;
      newArray.map((resp) => {
        if (resp?.id === data.id) {
          resp.id = data.id;
          resp.observation = e.target.value;
          resp.description = data?.description;
        }
        return newArray;
      });
      setValueExam(newArray);
    }
  };

  const handleChangeChecked = (e, data) => {
    if (data?.description === "Otro") {
      setOtherSelected(true);
    }
    if (e.target.checked === true) {
      setCheck(e.target.value);
      const list = {
        id: e?.target?.value,
        observation: "",
        description: data?.description,
      };
      setValueExam([...valueExam, list]);
    } else if (e?.target?.checked === false) {
      const newList = valueExam?.filter((x) => x?.id !== e?.target?.value);
      setValueExam(newList);
      //setValue(`observationExam[${e.target.value}]exams`, '');
      if (data?.description === "Otro") {
        setOtherSelected(false);
      }
    }
  };

  return (
    <div className={classes.divNextform}>
      <Grid container style={{ marginBottom: 15 }}>
        <Typography variant="h6">Información del empleado</Typography>
      </Grid>
      <form id="createOrderExam" onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              error={
                !!errors.hasOwnProperty("firstName") &&
                errors["firstName"].message
              }
            >
              <Controller
                name="firstName"
                control={control}
                defaultValue=""
                rules={{ required: true }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    InputLabelProps={{ shrink: true }}
                    type="text"
                    name="firstName"
                    label="Primer nombre *"
                    variant="outlined"
                    margin="dense"
                    size="small"
                    inputRef={register}
                    fullWidth
                    disabled={isFieldDisabled}
                    className={
                      isFieldDisabled
                        ? classes.inputFormDisabled
                        : classes.inputForm
                    }
                    error={
                      errors.hasOwnProperty("firstName") &&
                      errors["firstName"].message
                    }
                  />
                )}
              />
              <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                {errors.hasOwnProperty("firstName") &&
                  errors["firstName"].message}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3} lg={3}>
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              error={
                !!errors.hasOwnProperty("secondName") &&
                errors["secondName"].message
              }
            >
              <Controller
                name="secondName"
                control={control}
                defaultValue=""
                rules={{ required: true }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    InputLabelProps={{ shrink: true }}
                    type="text"
                    name="secondName"
                    label="Segundo nombre"
                    variant="outlined"
                    margin="dense"
                    size="small"
                    inputRef={register}
                    fullWidth
                    disabled={isFieldDisabled}
                    className={
                      isFieldDisabled
                        ? classes.inputFormDisabled
                        : classes.inputForm
                    }
                    error={
                      stateName
                        ? null
                        : errors.hasOwnProperty("secondName") &&
                          errors["secondName"].message
                    }
                  />
                )}
              />
              <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                {stateName
                  ? null
                  : errors.hasOwnProperty("secondName") &&
                    errors["secondName"].message}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3} lg={3}>
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              error={
                !!errors.hasOwnProperty("surname") && errors["surname"].message
              }
            >
              <Controller
                name="surname"
                control={control}
                defaultValue=""
                rules={{ required: true }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    InputLabelProps={{ shrink: true }}
                    type="text"
                    name="surname"
                    label="Primer apellido *"
                    variant="outlined"
                    margin="dense"
                    size="small"
                    disabled={isFieldDisabled}
                    inputRef={register}
                    fullWidth
                    className={
                      isFieldDisabled
                        ? classes.inputFormDisabled
                        : classes.inputForm
                    }
                    error={
                      errors.hasOwnProperty("surname") &&
                      errors["surname"].message
                    }
                  />
                )}
              />
              <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                {errors.hasOwnProperty("surname") && errors["surname"].message}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3} lg={3}>
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              error={
                !!errors.hasOwnProperty("secondSurname") &&
                errors["secondSurname"].message
              }
            >
              <Controller
                name="secondSurname"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    InputLabelProps={{ shrink: true }}
                    type="text"
                    name="secondSurname"
                    label="Segundo apellido"
                    variant="outlined"
                    margin="dense"
                    size="small"
                    disabled={isFieldDisabled}
                    inputRef={register}
                    fullWidth
                    className={
                      isFieldDisabled
                        ? classes.inputFormDisabled
                        : classes.inputForm
                    }
                    error={
                      stateSurname
                        ? null
                        : errors.hasOwnProperty("secondSurname") &&
                          errors["secondSurname"].message
                    }
                  />
                )}
              />
              <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                {stateSurname
                  ? null
                  : errors.hasOwnProperty("secondSurname") &&
                    errors["secondSurname"].message}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3} lg={3}>
            <FormControl
              variant="outlined"
              fullWidth
              className={classes.formControlGen}
              size="small"
              error={
                !!errors.hasOwnProperty("regionalId") &&
                errors["regionalId"].message
              }
            >
              <InputLabel htmlFor="outlined-select-regionalId" shrink={true}>
                Regional *
              </InputLabel>
              <Controller
                fullWidth
                control={control}
                name="regionalId"
                inputRef={register}
                defaultValue=""
                className={
                  isFieldDisabled
                    ? classes.inputFormDisabled
                    : classes.inputForm
                }
                label="Regional *"
                size="small"
                notched={true}
                disabled={isFieldDisabled}
                inputProps={{
                  name: "regionalId",
                  id: "outlined-select-regionalId",
                }}
                as={
                  <Select>
                    {regional.map((res) => (
                      <MenuItem
                        key={res?.id}
                        value={res?.id}
                        className={classes.menuItem}
                      >
                        {res.name}
                      </MenuItem>
                    ))}
                  </Select>
                }
              />
              <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                {errors.hasOwnProperty("regionalId") &&
                  errors["regionalId"].message}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3} lg={3}>
            <FormControl
              variant="outlined"
              fullWidth
              className={classes.formControlGen}
              size="small"
            >
              <InputLabel htmlFor="outlined-select-documentType" shrink={true}>
                Tipo de documento *
              </InputLabel>
              <Controller
                fullWidth
                control={control}
                name="documentType"
                inputRef={register}
                defaultValue=""
                className={classes.inputFormDisabled}
                disabled={true}
                label="Cargo a desempeñar *"
                size="small"
                notched={true}
                inputProps={{
                  name: "documentType",
                  id: "outlined-select-documentType",
                }}
                as={
                  <Select>
                    {dataMaestras?.maestras?.tipoDocumnetoIdentificacion.map(
                      (res) => (
                        <MenuItem
                          className={classes.menuItem}
                          key={res?.key}
                          value={res?.key}
                        >
                          {res?.value}
                        </MenuItem>
                      )
                    )}
                  </Select>
                }
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3} lg={3}>
            <FormControl fullWidth>
              <TextField
                InputLabelProps={{ shrink: true }}
                inputRef={register}
                type="text"
                name="document"
                defaultValue=""
                className={classes.inputFormDisabled}
                disabled={true}
                label="Número Documento *"
                variant="outlined"
                fullWidth
                size="small"
                margin="dense"
                onKeyPress={handleUserKeyPressDocumento}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3} lg={3}>
            <FormControl
              variant="outlined"
              fullWidth
              className={classes.formControlGen}
              size="small"
              error={
                !!errors.hasOwnProperty("examType") &&
                errors["examType"].message
              }
            >
              <InputLabel htmlFor="outlined-select-examType" shrink={true}>
                Tipo de orden *
              </InputLabel>
              <Controller
                fullWidth
                control={control}
                name="examType"
                inputRef={register}
                defaultValue=""
                className={classes.inputForm}
                label="Tipo de orden *"
                size="small"
                notched={true}
                inputProps={{
                  name: "examType",
                  id: "outlined-select-examType",
                }}
                as={
                  <Select>
                    {dataMaestras?.maestras?.tipoOrdenExamenMedico?.map(
                      (res) => (
                        <MenuItem
                          className={classes.menuItem}
                          key={res?.clave}
                          value={res?.clave}
                        >
                          {res?.valor}
                        </MenuItem>
                      )
                    )}
                  </Select>
                }
              />
              <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                {errors.hasOwnProperty("examType") &&
                  errors["examType"].message}
              </FormHelperText>
            </FormControl>
          </Grid>

          {!stateExamType ? (
            <Grid item xs={12} md={3} lg={3}>
              <FormControl
                fullWidth
                error={
                  stateExamType
                    ? null
                    : !!errors.hasOwnProperty("retiro") &&
                      errors["retiro"].message
                }
              >
                <MuiPickersUtilsProvider locale={deLocale} utils={DateFnsUtils}>
                  <Controller
                    control={control}
                    name="retiro"
                    placeholder="dd/mm/yyyy"
                    size="small"
                    defaultValue={null}
                    as={
                      <KeyboardDatePicker
                        fullWidth
                        inputRef={register}
                        inputVariant="outlined"
                        variant="inline"
                        margin="dense"
                        format="dd/MM/yyyy"
                        className={classes.inputForm}
                        label="Fecha de retiro"
                        InputLabelProps={{ shrink: true }}
                        error={
                          stateExamType
                            ? null
                            : errors.hasOwnProperty("retiro") &&
                              errors["retiro"].message
                        }
                        helperText={
                          stateExamType
                            ? null
                            : errors.hasOwnProperty("retiro") &&
                              errors["retiro"].message
                        }
                        minDate={"01.01.1900"}
                        minDateMessage={"No puede ser menor a 1900"}
                      />
                    }
                  />
                </MuiPickersUtilsProvider>
              </FormControl>
            </Grid>
          ) : null}

          <Grid item xs={12} md={3} lg={3}>
            <FormControl fullWidth>
              <TextField
                fullWidth
                variant="outlined"
                inputRef={register}
                type="text"
                defaultValue=""
                className={classes.inputForm}
                label="Correo electrónico *"
                name="email"
                size="small"
                margin="dense"
                placeholder="ejemplo@correo.com"
                InputLabelProps={{ shrink: true }}
                error={
                  errors.hasOwnProperty("email") && errors["email"].message
                }
                helperText={
                  errors.hasOwnProperty("email") && errors["email"].message
                }
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3} lg={3}>
            <FormControl
              variant="outlined"
              fullWidth
              className={classes.formControlGen}
              size="small"
              error={
                !!errors.hasOwnProperty("charge") && errors["charge"].message
              }
            >
              <InputLabel htmlFor="outlined-select-charge" shrink={true}>
                Cargo *
              </InputLabel>
              <Controller
                fullWidth
                control={control}
                name="charge"
                inputRef={register}
                defaultValue=""
                className={
                  isFieldDisabled
                    ? classes.inputFormDisabled
                    : classes.inputForm
                }
                label="Cargo *"
                size="small"
                notched={true}
                disabled={isFieldDisabled}
                inputProps={{
                  name: "charge",
                  id: "outlined-select-charge",
                }}
                as={
                  <Select>
                    {charges?.map((res) => (
                      <MenuItem
                        key={res?.id}
                        value={res?.id}
                        className={classes.menuItem}
                      >
                        {res.denomination}
                      </MenuItem>
                    ))}
                  </Select>
                }
              />
              <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                {errors.hasOwnProperty("charge") && errors["charge"].message}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={12} lg={12}>
            <Typography variant="h6">Tipo de examen</Typography>
            <Grid container spacing={2}>
              {typeExam?.map((data) => (
                <Grid item xs={12} md={12} lg={12}>
                  <Grid container alignItems="center">
                    <Grid item xs={2} md={1} lg={1} style={{ maxWidth: 50 }}>
                      <StyledCheckbox
                        color="success"
                        name="checkBox"
                        value={data?.id}
                        defaultChecked={null}
                        //checked={check === data?.id ? data?.id : false}
                        className={classes.checked}
                        onChange={(e) => handleChangeChecked(e, data)}
                        inputProps={{ "aria-label": "primary checkbox" }}
                        id={check}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={10}
                      md={6}
                      lg={6}
                      style={{ maxWidth: 350, paddingTop: 0 }}
                    >
                      <Typography>{data?.description}</Typography>
                    </Grid>
                    {otherSelected && data?.description === "Otro" ? (
                      <Grid item xs={12} md={4} lg={4}>
                        <FormControl fullWidth>
                          <TextField
                            InputLabelProps={{ shrink: true }}
                            type="text"
                            name={`observationExam[${data?.id}]exams`}
                            label="Cuál?*"
                            variant="outlined"
                            onChange={(e) => onChangeExam(e, data)}
                            margin="dense"
                            size="small"
                            inputRef={register}
                            inputProps={{ maxLength: 250 }}
                            fullWidth
                            className={classes.inputForm}
                            error={
                              errors.hasOwnProperty(
                                `observationExam[${data?.id}]exams`
                              ) &&
                              errors[`observationExam[${data?.id}]exams`]
                                .message
                            }
                          />

                          <FormHelperText
                            style={{ color: "#f44336", paddingLeft: 14 }}
                          >
                            {errors.hasOwnProperty(
                              `observationExam[${data?.id}]exams`
                            ) &&
                              errors[`observationExam[${data?.id}]exams`]
                                .message}
                          </FormHelperText>
                        </FormControl>
                      </Grid>
                    ) : null}
                  </Grid>
                </Grid>
              ))}
            </Grid>
          </Grid>

          <Grid item xs={12} md={12} lg={12}>
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              error={
                stateObservation
                  ? null
                  : !!errors.hasOwnProperty("observation") &&
                    errors["observation"].message
              }
            >
              <Controller
                name="observation"
                control={control}
                defaultValue=""
                rules={{ required: true }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    InputLabelProps={{ shrink: true }}
                    type="text"
                    name="observation"
                    label="Observaciones"
                    variant="outlined"
                    margin="dense"
                    size="small"
                    inputRef={register}
                    fullWidth
                    className={classes.inputForm}
                    error={
                      stateObservation
                        ? null
                        : errors.hasOwnProperty("observation") &&
                          errors["observation"].message
                    }
                  />
                )}
              />
              <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                {stateObservation
                  ? null
                  : errors.hasOwnProperty("observation") &&
                    errors["observation"].message}
              </FormHelperText>
            </FormControl>
          </Grid>
        </Grid>
      </form>
    </div>
  );
};

export default NextFormCreateOrder;
